import { useMemo } from 'react';
import { useEventLocale } from '@shared/core/i18n/LocaleContext';
import { DateFormat, formatDateForLanguage, FormatDateOptions, NullableDateInput } from './dateFormatter';

export const useFormattedDate = (input: NullableDateInput, format: DateFormat, options?: FormatDateOptions): string | undefined => {
  const { language } = useEventLocale();
  return useMemo(() => formatDateForLanguage(language, input, format, options), [input, format, options, language]);
};
